export const PAGE_TYPE = {
  PRODUCT_PAGE: 'productpages',
  COLLECTION_PAGE: 'collectionpages',
  HOME_PAGE: 'homepages',
  BLOG_PAGE: 'articlepages',
  LANDING_PAGE: 'landingpages',
}

export const PAGE_DEFAULT_TITLE = {
  "Your first Homepage": 1,
  "Theme Index Template": 1,
  "Theme Collection Template": 1,
  "Theme Product Template": 1
}

export const PAGE_EVENTS = {
  PUBLISHED: "schedule_publish"
}
